import { useQueryClient } from '@tanstack/react-query'

import {
  useIndividualsServicePostV1IndividualsByIndividualIdInviteUser,
} from '../client/queries'
import {
  useIndividualsServiceGetV1IndividualsByIndividualIdKey,
  useUsersServiceGetV1UsersMeKey,
} from '../client/queries/common'

export const useInviteToIndividual = () => {
  const queryClient = useQueryClient()

  return useIndividualsServicePostV1IndividualsByIndividualIdInviteUser({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useUsersServiceGetV1UsersMeKey],
      })
      queryClient.invalidateQueries({
        queryKey: [useIndividualsServiceGetV1IndividualsByIndividualIdKey],
      })
    },
  })
}
